import React, { Component } from "react";
import { GA_Push } from "../Services/Analytics"
import { _getCookie } from "../Services/Cookies";
import { scrollDown } from "../Services/scrollAnimation";
import VueRecaptcha from 'vue-recaptcha';
import { ReCaptcha } from 'react-recaptcha-google';

export default class FalaFelMeal extends Component {
    constructor(props) {
        super()
        this.state = {
            isChoosen: false
        }
        this.chooseMeal = this.chooseMeal.bind(this);
        this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        //window.sendCallback = this.sendVotes;
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.item.ID == this.props.removeSelected) {
            this.setState({
                isChoosen: false
            })
        }
        if (this.props.item.ID == this.props.chooseMeal) {
            this.chooseMeal();
        }
    }
    componentDidMount() {
        if (this.captchaDemo) {
            console.log("started, just a second...")
            console.log(this.captchaDemo)
            this.captchaDemo.reset();
            this.captchaDemo.execute();
        }
      }
      onLoadRecaptcha() {
        if (this.captchaDemo) {
            this.captchaDemo.reset();
            this.captchaDemo.execute();
        }
    }
    verifyCallback(recaptchaToken) {
      // Here you will get the final recaptchaToken!!!  
      console.log(recaptchaToken, "<= your recaptcha token")
    }
    chooseMeal() {
        if (!this.state.isChoosen && this.props.current >= 1) {
            this.props.triggerPopup({
                Title: "לא ניתן לבחור יותר מפעם אחת",
                Describe: ""
            }, "")
            return;
        }
        this.setState({
            isChoosen: !this.state.isChoosen
        })
        this.props.getMeal(this.props.item, (!this.state.isChoosen ? Math.round(this.props.current + 1) : Math.round(this.props.current - 1)));
    }
  
    render() {
        if (this.props.item.isLast) {
            return (
                
                <div
                    id="lastButton"
                    onClick={_getCookie("asdljlkads") ? () =>
                        this.props.triggerPopup({
                            Title: "לא ניתן להצביע פעם נוספת",
                            Describe: ""
                        }, "") : this.props.item.callback}
                    className={`option end ${_getCookie("asdljlkads") ? "voted" : ""}`}>
                    {/* <div
                         id="recaptcha-main"
                        className="g-recaptcha"
                        data-callback="sendCallback"
                        data-size="invisible"
                        data-sitekey="e06d9e8f4bcf209f1194083e9e33dc3d"
                    ></div> */}
                    <ReCaptcha
                        ref={(el) => {this.captchaDemo = el;}}
                        size="invisible"
                        render="explicit"
                        sitekey="e06d9e8f4bcf209f1194083e9e33dc3d"
                        onloadCallback={this.onLoadRecaptcha}
                        verifyCallback={this.verifyCallback}
                    />
                    <div className="image-rotate">
                        <div className="image">
                            <div className="head">
                                <div className="text">
                                    {this.props.item.Title}
                                </div>
                                <div className="arrow"></div>
                            </div>
                        </div>
                    </div>
                </div>
                
            )
        }
        return (
            <div
                onClick={() => { 
                    // GA_Push("Read_More_Business", `${this.props.item.Title}`);
                    
                    this.props.triggerPopup(this.props.item, this.state.isChoosen) }}
                className={`option image-${this.props.item.Image} ${(this.state.isChoosen ? " active" : "")}`}>
                <div className="image-rotate">
                    <div className={`image ${this.props.index <= 2 ? " image-friendly" : ""}`}>
                        {this.props.index <= 2 ? <div className="friendly">
                            <div className="friendly-text">
                                עסק חברתי
                            </div>
                        </div> : ""}
                        <div className="view"></div>
                        <div className="head">
                            {this.props.item.Title}
                        </div>
                    </div>
                </div>
                <div
                    onClick={(event) => {
                        event.stopPropagation();
                        // GA_Push(`Choose Business Button`, "Button");
                        
                        this.chooseMeal();
                        let lastButton = window.document.querySelector("#lastButton");
                        if (lastButton.className.indexOf("clickedVote") > -1) {
                            lastButton.classList.remove("clickedVote")
                        } else {
                            scrollDown("#footer", 20);
                            lastButton.classList.add("clickedVote")
                        }
                    }}
                    className={`button`}>
                    <div className="bg">
                        <div className="text">
                            {`${(this.state.isChoosen ? "הסרה" : "בחר/י")}`}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/ManotFalafel/ManaFalafel.Meal.jsx